import { hijos } from './hijos.model';

export class permits {
    public nombre: string;
    public id:number;
    public hijos: Array<hijos>;
}